import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import { Industries, POSSolution, POSSolutions } from "../../file.interface";
import { ScreenContainer } from "../../components/containers";
const industriesList: Industries[] = Object.values(Industries);

const IndustriesScreen1: React.FC = () => {
  const { selectedIndustry, dispatch } = useAppContext();
  const navigate = useNavigate();

  const handleIndustryClick = (industry: Industries): void => {
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: { selectedIndustry: industry },
    });
  };

  const handleNavigation = () => {
    if (selectedIndustry === Industries.Custom) {
      navigate("/features-screen-2");
    } else {
      if (selectedIndustry)
        updatePOSSolution(
          POSSolutions.filter((solution) =>
            solution.industries.includes(selectedIndustry)
          )[0]
        );
      navigate("/duration-screen-2");
    }
  };

  const updatePOSSolution = (solution: POSSolution): void => {
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: { selectedPOSSolution: solution },
    });
  };

  return (
    <ScreenContainer title="What industry are you in?">
      <div className="industries-container">
        {industriesList.map((industry, i) => (
          <div
            key={i}
            onClick={() => handleIndustryClick(industry)}
            className={`industry-item ${
              selectedIndustry === industry ? "industry-selected" : ""
            }`}
          >
            {industry}
          </div>
        ))}
      </div>
      {selectedIndustry && (
        <button className="app-button next-button" onClick={handleNavigation}>
          Next
        </button>
      )}
    </ScreenContainer>
  );
};

export default IndustriesScreen1;
